export const sortByIndex = (arr) => {
	return arr.sort((a, b) => a.index > b.index ? 1 : -1)
}
